import styled from 'styled-components';
export const NoticeContainer =styled.div`
    padding : 1.5rem;
`
export const NoticeBox = styled.div`
    white-space : pre-line;
    box-sizing : border-box;
    margin-bottom : 20px;
`
export const ReasonBox =styled.div`
    padding :0 0 20px 0;
    box-sizing : border-box;
`
export const Reason = styled.textarea`
    width : 100%;
    min-height : 40px;
    margin-top : 10px;
    padding : 18px;
    text-align : left;
    box-sizing : border-box;
    resize : none;
    ::placeholder{
      font-size : 12px;  
    }
`

export const BtnBox =styled.div`
    display : flex;
`
export const Cancel = styled.div`
    flex : 1;
    div{
        width : 100px;
        margin : auto;
        background : #fff;
        border : 1px solid #1fbdcb;
        color :#1fbdcb;
        padding : 8px 25px;
        font-size : 12px;
        cursor: pointer;
        border-radius : 4px;
    }
   
`
export const RefundOrCancel = styled(Cancel)`
    div{
        border :  ${props =>props.active ? "#1fbdcb" : "#f1f1f1"};
        cursor : ${props =>props.active ? "pointer" : "default"};
        background : ${props =>props.active ? "#1fbdcb" : "#f1f1f1"};
        color : ${props =>props.active ? "#fff" : "#c8c8c8"};
    }
`

export const Title = styled.div`
    font-size : 20px;
    margin-bottom : 10px;
    font-weight : 900;
    span{
        color : #1fbdcb;
    }
`
export const Text =styled.div`
    font-size : 16px;
`
